import { useSelector } from 'react-redux';

import { SELECTED_REGION } from 'app/constants/cookieKeys';
import { getDefaultRegion, isMultiDomain } from 'app/lib/site-configs/selectors';
import { isSSR } from 'app/packages/components';
import { cookie } from 'app/packages/lib';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

const useCurrentRegion = () => {
  const isMulti = useSelector(isMultiDomain);
  const defaultRegion = useSelector(getDefaultRegion);
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (isMulti || isLoggedIn) {
    return defaultRegion;
  }

  return (!isSSR && cookie.getCookieByKey(SELECTED_REGION)) || defaultRegion;
};

export default useCurrentRegion;
